import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportmanagement',
  templateUrl: './reportmanagement.component.html',
  styleUrls: ['./reportmanagement.component.css']
})
export class ReportmanagementComponent implements OnInit {
  loginresponse:any;
  userrole:any;
  farm_userrole:any;
  hidden:boolean=true;
  constructor() { }
 
  ngOnInit(): void {

    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    console.log(this.loginresponse);
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;

    if(this.farm_userrole){
      this.hidden=false;
    }

  }

}
